import React, { useMemo } from 'react';

import { IRegionShort, IRelatedForRegion } from 'api/region/types';

import { fetchRegionRelated } from 'api/region/static';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { isMainLocale } from 'util/i18nFlags';

import { TabsNavigationRedesign } from 'components/common/TabsNavigationRedesign';

import { useFakeQueryWithInitialValue } from 'util/useQueryWithInitialValue';
import {
  CurrentLink, CurrentTab, linksPlan, linksSnow,
} from './constants';
import { RegionRelatedDataHeader } from '../RegionRelatedDataHeader';

export const RegionHeaderNav = ({ region, link, related: preRelated }: {
  region: IRegionShort,
  tab: CurrentTab,
  link: CurrentLink,
  related: IRelatedForRegion,
}) => {
  const { t } = useOTSTranslation('common');

  const { current: related } = useFakeQueryWithInitialValue(['region-related', region.uuid], () => fetchRegionRelated(region.uuid), preRelated);

  const linksSnowPart = useMemo(() => linksSnow(region, t), [region, t]);
  const linksPlanningPart = useMemo(
    () => (isMainLocale() ? linksPlan(region, t) : null),
    [region, t],
  );

  return (
    <>
      <TabsNavigationRedesign
        linkItemsLeft={linksSnowPart}
        linkItemsRight={linksPlanningPart}
        link={link}
      >
        <RegionRelatedDataHeader
          regionName={region.title}
          related={related}
        />
      </TabsNavigationRedesign>
    </>
  );
};
